module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Spring Boot  provides additional tools to enhance the development process. As part of Spring Boot-1.3.  Spring Boot Devtools  module was…","fields":{"slug":"/spring-boot-devtools-automatic-restart/"},"frontmatter":{"title":"Enable Spring Boot Developer Tools: automatic restart on file change","date":"04 November, 2019"}}}]}},"pathContext":{"tag":"boot"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-boot.json
// module id = 489
// module chunks = 246068411614932